module.exports = __webpack_public_path__ + "static/RoslindaleVariableDeck-VF-e5875db8131378e0c6b0df465b7df3d3.woff2";